import React from "react";

const PlayerExitIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clipPath5565616541">
          <path
            d="M0 0L32 0L32 32L0 32L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 -0 -0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath5565616541)">
        <path
          d="M10.0607 -1.06066C9.47488 -1.64644 8.52512 -1.64644 7.93934 -1.06066L-1.06066 7.93934Q-1.11277 7.99145 -1.15952 8.04841Q-1.20626 8.10537 -1.2472 8.16664Q-1.28814 8.22791 -1.32288 8.2929Q-1.35762 8.35789 -1.38582 8.42597Q-1.41402 8.49406 -1.43541 8.56457Q-1.4568 8.63509 -1.47118 8.70736Q-1.48555 8.77964 -1.49278 8.85297Q-1.5 8.92631 -1.5 9Q-1.5 9.07369 -1.49278 9.14703Q-1.48555 9.22036 -1.47118 9.29263Q-1.4568 9.36491 -1.43541 9.43543Q-1.41402 9.50594 -1.38582 9.57402Q-1.35762 9.64211 -1.32288 9.70709Q-1.28814 9.77208 -1.2472 9.83335Q-1.20626 9.89463 -1.15952 9.95159Q-1.11277 10.0086 -1.06066 10.0607L7.93934 19.0607C8.52512 19.6464 9.47488 19.6464 10.0607 19.0607C10.6464 18.4749 10.6464 17.5251 10.0607 16.9393L2.12132 9L10.0607 1.06066C10.6464 0.474878 10.6464 -0.474879 10.0607 -1.06066Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 11.5 7)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default PlayerExitIcon;
